import type { TaskTemplateType } from '@econtractor/types';
import { useTranslation } from 'react-i18next';
import TableEmptyRow from 'components/others/TableEmptyRow';
import TaskDirTableRow from './TaskDirTableRow';

interface TaskDirTableBodyProps {
    templates: TaskTemplateType[];
    colSpan: number;
    hideExecutor?: boolean;
    onSelect?: (template: TaskTemplateType) => void;
    onEdit?: (template: TaskTemplateType) => void;
    onDelete?: (template: TaskTemplateType) => void;
}

const TaskDirTableBody = ({
    templates,
    colSpan,
    hideExecutor = false,
    onSelect,
    onEdit,
    onDelete,
}: TaskDirTableBodyProps) => {
    const { t } = useTranslation(['Tasks']);

    return (
        <tbody>
            {!templates.length ? (
                <TableEmptyRow colSpan={colSpan} className="text-muted text-center py-4">
                    {t('directory.empty')}
                </TableEmptyRow>
            ) : (
                templates.map((template) => (
                    <TaskDirTableRow
                        key={template.ID}
                        template={template}
                        hideExecutor={hideExecutor}
                        onSelect={onSelect}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />
                ))
            )}
        </tbody>
    );
};

export default TaskDirTableBody;
